import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=12917ab3&"
import script from "./FormCheck.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FormCheck.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports